import { createAsyncThunk, createSelector, createSlice, } from "@reduxjs/toolkit";
import * as api from "../../api/api";
import { buildClubLinks, formationsById, } from "../../utils/squadMetaRating";
const initialState = {
    images: [],
    versionAssets: {},
    countries: [],
    leagues: [],
    clubs: [],
    versions: [],
    //   formations: {},
    versionsStatus: "idle",
    //   formationsStatus: 'idle',
    leaguesCountriesClubsStatus: "idle",
    //   chemistryProfilesStatus: 'idle',
    //   chemistryProfiles: {} as ChemistryProfiles,
    chemstyleBonuses: {},
    chemstyleBonusesStatus: "idle",
    eventTokens: [],
    eventTokensStatus: "idle",
    formations: {},
    chemistryProfiles: undefined,
    clubLinks: {},
};
const PREMIER_LEAUGE_ID = 13;
const LA_LIGA_ID = 53;
const BUNDESLIGA_ID = 19;
const LIGUE_1_ID = 16;
const SERIE_A_ID = 31;
const ARGENTINA_ID = 52;
const BRAZIL_ID = 54;
const ENGLAND_ID = 14;
const FRANCE_ID = 18;
const GERMANY_ID = 21;
const NETHERLANDS_ID = 34;
const ITALY_ID = 27;
const PORTUGAL_ID = 38;
const SPAIN_ID = 45;
export const TOP_FIVE_LEAGUE_IDS = [
    PREMIER_LEAUGE_ID,
    LA_LIGA_ID,
    BUNDESLIGA_ID,
    LIGUE_1_ID,
    SERIE_A_ID,
];
export const TOP_NINE_COUNTRY_IDS = [
    ENGLAND_ID,
    SPAIN_ID,
    GERMANY_ID,
    FRANCE_ID,
    ITALY_ID,
    PORTUGAL_ID,
    NETHERLANDS_ID,
    BRAZIL_ID,
    ARGENTINA_ID,
];
/**
 * All start-up data in one request (DEV-4013). Each slice that owns a section
 * fills it from `fetchBaseData.fulfilled`.
 */
export const fetchBaseData = createAsyncThunk("base-data", async () => {
    const baseData = await api.getBaseData();
    const { managerData } = baseData;
    managerData.countries = managerData.countries.sort((a, b) => {
        if (TOP_NINE_COUNTRY_IDS.includes(a.id) &&
            !TOP_NINE_COUNTRY_IDS.includes(b.id)) {
            return -1;
        }
        if (!TOP_NINE_COUNTRY_IDS.includes(a.id) &&
            TOP_NINE_COUNTRY_IDS.includes(b.id)) {
            return 1;
        }
        return a.name.localeCompare(b.name);
    });
    managerData.leagues = managerData.leagues.sort((a, b) => {
        if (TOP_FIVE_LEAGUE_IDS.includes(a.id) &&
            !TOP_FIVE_LEAGUE_IDS.includes(b.id)) {
            return -1;
        }
        if (!TOP_FIVE_LEAGUE_IDS.includes(a.id) &&
            TOP_FIVE_LEAGUE_IDS.includes(b.id)) {
            return 1;
        }
        return a.name.localeCompare(b.name);
    });
    baseData.playerRoles = baseData.playerRoles?.sort((a, b) => b.id - a.id);
    return baseData;
});
const LoadedContentSlice = createSlice({
    name: "loadedContent",
    initialState,
    reducers: {
        setImageLoaded(state, action) {
            if (!state.images.find((imageLoaded) => action.payload === imageLoaded)) {
                state.images = [...state.images, action.payload];
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBaseData.pending, (state) => {
            state.versionsStatus = "pending";
            state.leaguesCountriesClubsStatus = "pending";
            state.chemstyleBonusesStatus = "pending";
            state.eventTokensStatus = "pending";
        })
            .addCase(fetchBaseData.fulfilled, (state, action) => {
            const { versionAssets, managerData, chemstyleBonuses, eventTokens } = action.payload;
            state.versionAssets = versionAssets;
            state.versions = Object.keys(versionAssets).map((key) => ({
                id: parseInt(key),
                name: versionAssets[key]?.name ?? "",
                hasLevels: versionAssets[key]?.hasLevels ?? false,
            }));
            state.versionsStatus = "fulfilled";
            state.countries = managerData.countries;
            state.leagues = managerData.leagues;
            state.clubs = managerData.clubs;
            state.leaguesCountriesClubsStatus = "fulfilled";
            state.chemstyleBonuses = chemstyleBonuses;
            state.chemstyleBonusesStatus = "fulfilled";
            state.eventTokens = eventTokens;
            state.eventTokensStatus = "fulfilled";
            state.formations = formationsById(action.payload.formations);
            state.chemistryProfiles = action.payload.chemistryProfiles;
            state.clubLinks = buildClubLinks(managerData.clubs);
        })
            .addCase(fetchBaseData.rejected, (state) => {
            state.versionsStatus = "rejected";
            state.leaguesCountriesClubsStatus = "rejected";
            state.chemstyleBonusesStatus = "rejected";
            state.eventTokensStatus = "rejected";
        });
        //   .addCase(getFormations.fulfilled, (state, action) => {
        //     state.formations = action.payload;
        //     state.formationsStatus = 'fulfilled';
        //   })
        //   .addCase(getFormations.rejected, (state) => {
        //     state.formationsStatus = 'rejected';
        //   })
        //   .addCase(fetchChemistryProfiles.fulfilled, (state, action) => {
        //     state.chemistryProfiles = action.payload;
        //     state.chemistryProfilesStatus = 'fulfilled';
        //   })
        //   .addCase(fetchChemistryProfiles.pending, (state) => {
        //     state.chemistryProfilesStatus = 'pending';
        //   })
        //   .addCase(fetchChemistryProfiles.rejected, (state) => {
        //     state.chemistryProfilesStatus = 'rejected';
        //   });
    },
});
// export const getCountriesSelector = (country: number) => (state: IRootState) =>
//   state.loadedContentReducer.countries?.find((c) => c.id === country);
// export const getLeaguesSelector = (league: number) => (state: IRootState) =>
//   state.loadedContentReducer.leagues?.find((l) => l.id === league);
// export const getClubsSelector = (club: number) => (state: IRootState) =>
//   state.loadedContentReducer.clubs?.find((c) => c.id === club);
export const getVersionAssetsSelector = (state) => state.loadedContentReducer.versionAssets;
export const eventTokensSelector = (state) => state.loadedContentReducer.eventTokens;
/**
 * The rarities a filter can offer, newest first — the order web's dropdown
 * uses, so whatever just dropped sits at the top rather than buried among a
 * hundred past promos. Hidden versions are EA's own and filter nothing.
 */
export const rarityOptionsSelector = createSelector(getVersionAssetsSelector, (versionAssets) => Object.entries(versionAssets)
    .filter(([, version]) => !version.hidden)
    .sort(([, a], [, b]) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .map(([id, version]) => ({ id: Number(id), name: version.name })));
export const getLoadedImages = (state) => state.loadedContentReducer.images;
export const loadedContentSelector = (state) => state.loadedContentReducer;
export const chemstyleBonusesSelector = (state) => state.loadedContentReducer.chemstyleBonuses;
export const formationsByIdSelector = (state) => state.loadedContentReducer.formations;
export const chemistryProfilesSelector = (state) => state.loadedContentReducer.chemistryProfiles;
export const clubLinksSelector = (state) => state.loadedContentReducer.clubLinks;
// export const formationsSelector = (state: IRootState) => {
//   return state.loadedContentReducer.formations;
// };
// export const formationsAsListSelector = (
//   state: IRootState,
// ): FormationsAsList => {
//   return Object.entries(state.loadedContentReducer.formations).map(
//     ([formationId, formation]) => ({
//       id: formationId,
//       ...formation,
//     }),
//   );
// };
// export const getFormationsLabel =
//   (formationId: string) => (state: IRootState) =>
//     state.loadedContentReducer.formations[formationId]?.label;
// export const getFormationData =
//   (formationId: string) => (state: IRootState) => {
//     const formation = state.loadedContentReducer.formations[formationId];
//     if (!formation) return null;
//     return {
//       labels: formation.positions.slice(0, 11),
//       uniquePositions: formation.uniquePositions.slice(0, 11),
//       coordinates: formation.pitchCoordinates.map((coord) => ({
//         x: coord.x,
//         y: coord.y,
//       })),
//     };
//   };
export const { setImageLoaded } = LoadedContentSlice.actions;
export default LoadedContentSlice.reducer;
//# sourceMappingURL=loadedContentSlice.js.map